await themeComponent(theme.components['mc-element'], false);

class McRefresher extends McElement {
    constructor(){
        super()
    }

    connectedCallback() {
        this.refreshables = this.querySelectorAll('[data-refreshable]');
        this.addEventListener(MCEVENTS.RELOAD_REQUESTED, (event) => {
            this.reload(event.detail);
        })
    }

    reload = (response) => {
        const doc = McUtils.getDocument(response);
        console.log(response);
        this.refreshables.forEach(element => {
            console.log(element);
            element.reload(doc);
        });
        //In case of refreshception.
        this.refreshables = this.querySelectorAll('[data-refreshable]');
    }
}
if(!window.customElements.get('mc-refresher')){
    window.customElements.define('mc-refresher', McRefresher);
}
window.McRefresher = McRefresher;